<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="margin-top: 2%">

        <template>


        <div v-if="htop">
     <vue-html2pdf
        :show-layout="false"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="filename"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"

        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
    >
        <section slot="pdf-content" style="padding:0px!important;margin:0px!important">
       
                    NBRE PRODUITS = {{produitComs.length}} <br>
                    {{user.relation.nom}} <br>
                    {{user.relation.slogan}} <br>
                    <span> IFU : {{user.relation.ifu}} </span> <span style="margin-left:10px">  <i class="bx bxs-map "></i> {{user.relation.quartier.nom}} </span> <span style="margin-left:10px"> <i class="bx bxs-phone "></i>  {{user.relation.phone}}  </span>  <br>
                    <span> Ticket: N° {{ order.reference}} </span> 
                    <span style="margin-left:10px"> {{ getformatDate(order.created_at)}} </span> <br>
                    <span> Vendeur: {{ (order.origin=="manuel"?order.user_pharma.name:"En ligne") }} </span> 
                    <span style="margin-left:10px"> Caisse : {{caissier }} </span> <br>
                    <span style="font-weight:bold">Liste des produits : </span> <br>
                    <ul style="margin-right:2%">
                        <li v-for="(item, index) in produitComs" :key="index" class="row"> 
                       
                            <div class="col-6">
                              ({{index+1}})  {{item.produit_name}}
                            </div>
                            <div class="col-4">
                                {{item.prix_achat}} x {{item.qte}}
                            </div>
                            <div class="col-2">
                                {{parseInt(item.prix_achat) * parseInt(item.qte)}}
                            </div>
                        </li>
                    </ul>   
                    <span style="font-weight:bold"> Montant HT : {{ order.pharma_total  }} XOF </span> <br>
                     <span style="font-weight:bold"> Montant TVA : 0 XOF </span> <br>

        </section>
    </vue-html2pdf>
   </div>

        </template>

        <template>
            <v-row justify="center">
                <v-dialog v-model="dialog"  style="z-index: 1058" persistent max-width="900px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Les produits de la commande : {{refCom}} 

                             </span>
                             <v-chip color="primary"
                                                style="color: white; cursor:pointer;margin-left: 15px">
                                           Total :  {{order.pharma_total}} XOF
                                        </v-chip>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-data-table
                                        :headers="headers2"
                                        :items="produitComs"
                                        :search="search"
                                        sort-by="name"
                                        class="elevation-1"
                                        :loading="produitComs.length==0" loading-text="Chargement en cours...">


                                    <template v-slot:item.produit_img="{item}">
                                        <a v-if="item.produit_img" :href="item.produit_img.substr(7)" target="_blank">
                                            <img :src="item.produit_img.substr(7)"
                                                 style="width: 50px; height: 50px;cursor: pointer; margin: 2% "
                                                 data-toggle="modal" data-target="#infos"/>
                                        </a>
                                    </template>

                                    <template v-slot:item.prix_achat="{ item }">
                                        <p style="font-weight: bold; font-size: 10pt">{{item.prix_achat}} XOF</p>
                                    </template>


                                    <template v-slot:item._id="{ item }">
                                        <p style="font-weight: bold; font-size: 10pt">{{item.prix_achat * item.qte}}
                                            XOF</p>
                                    </template>


                                    <template v-slot:item.etat_get="{ item }">
                                        <v-chip :color="(item.etat_get!='false')?'green':'red'"
                                                style="color: white; cursor:pointer;">
                                            {{(item.etat_get=="false")?'En attente':'Déjà récupéré'}}
                                        </v-chip>
                                    </template>

                                    <template v-slot:item.pharma_user_slug="{ item }">
                                        <p v-if="item.pharma_user_slug!=null"
                                           style="font-weight: bold; font-size: 10pt">
                                            {{item.pharma_user_slug.name}}
                                            </p>
                                    </template>


                                    <template v-slot:item.get_time="{item}">
                                        <span v-if="item.get_time!=''"> {{ getformatDate(item.get_time)}}</span>
                                        <span v-else> --- </span>
                                    </template>


                                    <template v-slot:no-data>
                                        <v-btn color="default" @click="initialize">Actualiser</v-btn>
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                             <v-btn color="blue darken-1" text @click="generateReport">
                             <v-progress-circular v-if="factureload" indeterminate size="20"
                                                                     style="margin-left: 5px"></v-progress-circular> Facture</v-btn>
                            
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>

        </template>

        <v-card>
            <v-card-title>

                <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher une commande ..."
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="precommandesEff"
                    :search="search"
                    sort-by="name"
                    class="elevation-1"
                    :loading="precommandesEffloading" loading-text="Chargement en cours...">

                <template v-slot:item.reference="{ item }">
                    <v-chip @click="listProd(item)" color="#046089" style="color: white; cursor:pointer;">
                        <v-icon small class="mr-2">
                            mdi-eye
                        </v-icon>
                        {{ item.reference }}
                    </v-chip>
                </template>

                <template v-slot:item.state_paye="{ item }">
                    <v-chip :color="(item.state_paye=='SUCCESS')?'green':'orange'" style="color: white; cursor:pointer;">{{
                        item.state_paye }}
                    </v-chip>
                </template>
                <template v-slot:item.pharma_get="{ item }">
                    <v-chip :color="(item.pharma_get!='false')?'green':'red'" style="color: white; cursor:pointer;">
                        {{(item.pharma_get=="false")?'En attente':'Déjà récupéré'}}
                    </v-chip>
                </template>

                <template v-slot:item.pharma_total="{ item }">
                    <h5 style="font-weight: bold">{{item.pharma_total}} XOF</h5>
                </template>


                <template v-slot:item.created_at="{item}">
                    {{ getformatDate(item.created_at)}}
                </template>
                <template v-slot:no-data>
                    <v-btn color="default" @click="initialize">Actualiser</v-btn>
                </template>
            </v-data-table>
        </v-card>

        <v-snackbar
                v-model="snackbar"
                timeout="2000"
        >
            {{ textSnack }}

            <template v-slot:action="{ attrs }">
                <v-btn
                        color="blue"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                >
                    Fermer
                </v-btn>
            </template>
        </v-snackbar>




    </div>
</template>

<script>
    import {mapState} from "vuex";
    import VueHtml2pdf from 'vue-html2pdf'

   // import * as Swal from "sweetalert2";

    export default {
        name: "Precommande",
        components: {
            VueHtml2pdf
        },
        data() {
            return {
                submitting: false,
                factureload:false,
                filename:"",
                user: JSON.parse(localStorage.getItem("user")),
                valid: true,
                lazy: false,
                htop:false,
                errors: undefined,
                search: '',
                dialog: false,
                id: undefined,
                snackbar: false,
                textSnack: '',
                refCom: '',
                produitComs: '',
                caissier:'',
                order:'',
                headers: [
                    {
                        text: 'Référence',
                        align: 'start',
                        sortable: true,
                        value: 'reference',
                    },
                    {text: 'Client', value: 'client_slug.name', sortable: false},
                    {text: 'Contact d\'urgence', value: 'phone_client', sortable: false},
                    {text: 'Etat paiement', value: 'state_paye', sortable: false},
                    {text: 'Réception client', value: 'pharma_get', sortable: false},
                    {text: 'Montant payé', value: 'pharma_total', sortable: false},
                    {text: 'Date', value: 'created_at', sortable: false},

                ],
                headers2: [
                    {
                        text: 'Image',
                        align: 'start',
                        sortable: true,
                        value: 'produit_img',
                    },
                    {text: 'Produit', value: 'produit_name', sortable: false},
                    {text: 'Prix d\'achat', value: 'prix_achat', sortable: false},
                    {text: 'Quantité', value: 'qte', sortable: false},
                    {text: 'Réception client', value: 'etat_get', sortable: false},
                    {text: 'Livrer par', value: 'pharma_user_slug', sortable: false},
                    {text: 'Sous Total', value: '_id', sortable: false},
                    {text: 'Produit reçu', value: 'get_time', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
               
            }

            }
        
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle catégorie" : "Mise à jour"
            }
            ,
            ...mapState('precommandes/', ['precommandesEff','precommandesEffloading'])

        }
        ,
        mounted() {
            let data = new FormData();
            data.append("state_client_get", "false");
            data.append("pharmacie", this.user.relation._id);
            data.append("pharma_get", "true");
            this.$store.dispatch('precommandes/getPrecommandeEff', data).then(response => {
                window.console.log('precommandes', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            onProgress($event){
                this.factureload = true;
                if($event==100){this.factureload = false;}
                console.log("onProgress",$event)
            },
            hasStartedGeneration(){
                console.log("hasStartedGeneration")
            },
            hasGenerated($event){

                console.log("hasGenerated",$event)

            },
            generateReport () {
               
                
                this.$refs.html2Pdf.generatePdf();
                
            }
            ,
            listProd(item) {
                 this.htop = true;
                this.order = item; 
                this.produitComs = item.all_precommande_produit;
                this.refCom = item.reference;
                this.filename = item.reference;
                this.caissier = this.produitComs[0].pharma_user_slug.name;
                console.log("this.order",this.order);
                this.dialog = true;

            }
            ,
            close() {
                this.htop = false;
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
               // this.$refs.form.reset()
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor() {
                return "#009587";
            },
            getformatDate(value) {
                if (value) {
                    return Intl.DateTimeFormat('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"
                    }).format(new Date(value));
                }
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>